






























































































































































































































































































































import BaseComponent from '../../../core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import {
  CompanyDto,
  CompanyDistrictDto,
  CompanyDistrictListDto,
} from '../../../dto';
import CompanyService from '../../../services/company.service';
import CompanyDistrictService from '../../../services/company-district.service';
import { Pagination } from '../../../common';
import { CodeManagementDto } from '../../../services/init/dto';
import {
  APPROVAL_STATUS,
  CONST_APPROVAL_STATUS,
} from '../../../services/shared';

import AmenityService from '../../../services/amenity.service';

import { FileAttachmentDto } from '@/services/shared/file-upload';
import FileUploadService from '../../../services/shared/file-upload/file-upload.service';
import { UPLOAD_TYPE } from '../../../services/shared/file-upload/file-upload.service';
import { ATTACHMENT_REASON_TYPE } from '@/services/shared/file-upload';

import { getStatusColor } from '../../../core/utils/status-color.util';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';
import { CompanyDistrictCreateDto } from '@/dto';
import toast from '../../../../resources/assets/js/services/toast.js';

@Component({
  name: 'CompanyDistrictList',
})
export default class CompanyDistrictList extends BaseComponent {
  private companyDistrictList: CompanyDistrictDto[] = Array<
    CompanyDistrictDto
  >();
  private companyDistrictTotalCount = null;
  private companyDistrictSearchDto = new CompanyDistrictListDto();
  private pagination = new Pagination();
  private approvalStatus: APPROVAL_STATUS[] = [...CONST_APPROVAL_STATUS];
  private companyDistrictCreateDto = new CompanyDistrictCreateDto();
  private companySelect: CompanyDto[] = [];
  private dataLoading = false;
  private addressData = {
    address: '',
  };

  private commonAmenityList = [];
  private districtImage = [];

  // get status color
  getStatusColor(status: APPROVAL_STATUS) {
    return getStatusColor(status);
  }

  // get company list
  getCompanies() {
    CompanyService.findAllForSelect().subscribe(res => {
      this.companySelect = res.data;
    });
  }

  // show address modal
  showAddressModal() {
    this.$bvModal.show('postcode');
  }

  // set address info
  setAddress(res) {
    this.addressData = res;
    this.companyDistrictCreateDto.address = this.addressData.address;

    const geocoder = new window.kakao.maps.services.Geocoder();
    const callback = (results, status) => {
      if (status === window.kakao.maps.services.Status.OK) {
        this.companyDistrictCreateDto.lon = results[0].x;
        this.companyDistrictCreateDto.lat = results[0].y;
        this.companyDistrictCreateDto.region1DepthName =
          results[0].address.region_1depth_name;
        this.companyDistrictCreateDto.region2DepthName =
          results[0].address.region_2depth_name;
        this.companyDistrictCreateDto.region3DepthName =
          results[0].address.region_3depth_name;
        this.companyDistrictCreateDto.hCode = results[0].address.h_code;
        this.companyDistrictCreateDto.bCode = results[0].address.b_code;
      }
    };
    geocoder.addressSearch(this.companyDistrictCreateDto.address, callback);
    this.$bvModal.hide('postcode');
  }

  // serach district
  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    if (!isPagination) {
      this.pagination.page = 1; // 최초 페이지 진입시 페이지 초기화
    } else {
      if (isSearch) this.pagination.page = 1; // 검색버튼 클릭시 페이지 초기화
      RouterQueryParamMapper(this.companyDistrictSearchDto, this.pagination);
    }
    CompanyDistrictService.findAll(
      this.companyDistrictSearchDto,
      this.pagination,
    ).subscribe(res => {
      if (res) {
        this.dataLoading = false;
        this.companyDistrictList = res.data.items;
        this.companyDistrictTotalCount = res.data.totalCount;
      }
    });
  }

  // paginate
  paginateSearch() {
    this.findAll(true);
  }

  // search
  search() {
    this.findAll(true, true);
  }

  // clear out district search dto
  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.companyDistrictSearchDto = new CompanyDistrictListDto();
      this.findAll();
    }
  }

  // create company district
  createCompanyDidstrict() {
    if (this.districtImage.length > 0) {
      this.companyDistrictCreateDto.image = this.districtImage;
    }
    CompanyDistrictService.createCompanyDistrict(
      this.companyDistrictCreateDto,
    ).subscribe(res => {
      toast.success('추가완료');
      this.clearOut();
    });
  }

  // clear out company district create dto
  clearOutCreateDto() {
    this.districtImage = [];
    this.companyDistrictCreateDto = new CompanyDistrictDto();
  }

  async upload(file: File) {
    const attachments = await FileUploadService.upload(
      UPLOAD_TYPE.COMPANY_DISTRICT,
      [file],
    );
    this.districtImage = [];
    this.districtImage.push(
      ...attachments.filter(
        fileUpload =>
          fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
      ),
    );
  }

  // get common facility
  getAmenities() {
    AmenityService.findAmenities('common-facility').subscribe(res => {
      this.commonAmenityList = res.data;
    });
  }

  created() {
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.companyDistrictSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
    this.getCompanies();
    this.getAmenities();
  }
}
